import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import FiltersRow from './FiltersRow/FiltersRow';

const TableHead = () => {
    const displayUsageDetails = useSelector(
        (state) => state.daylight.userHasAccessToCodeUsageDetails,
        shallowEqual
    );

    return (
        <thead>
            <tr className="bg-dark text-light sticky-top">
                <th scope="col" className="col col-x-small">Row</th>
                <th scope="col" className="col col-medium">Category</th>
                <th scope="col" className="col col-small">Code</th>                
                <th scope="col" className="col col-med-large">Description</th>
                <th scope="col" className="text-nowrap col col-small"><abbr title='Legacy Sale Price'>LSP</abbr></th>
                <th scope="col" className="col col-small">Location</th>
                {displayUsageDetails && <th scope="col" className="col col-medium">Usage Details</th>}
                <th scope="col" className="col col-small"><abbr title='Trailing Twelve Months'>TTM</abbr></th>
                <th scope="col" className="col col-large">Mappings</th>
                {/* empty col-smallumn to put the row action buttons */}
                <th scope="col" className="col col-actions">&nbsp;</th>
            </tr>
            <FiltersRow />
        </thead>
    );
};

export default TableHead;
